enum RouteEnums {
    HOMEPAGE="/",
    ABOUT="/about",
    EXPERIENCE="/experience",
    MYGITHUB="/mygithub",
    APPS="/apps"
}

export default RouteEnums;
